import React, { useEffect } from 'react';
import CenterStage from '../Components/CenterStage/CenterStage';
import imgHANSAFLEX_Ireland_career_cover from '../assets/Home/HANSAFLEX_Ireland_Hydraulicervicevan_Homepage.webp';
import Promoter from '../Components/Promoter/Promoter';
import { Col, Row } from 'react-bootstrap';
import { MdEmail, MdLocationOn } from 'react-icons/md';
import imgHANSAFLEX_Ireland_career_contactus from '../assets/Careers/HANSAFLEX_Ireland_career_contactus.webp';
import TwoColumnPoints from '../Components/TwoColumnPoints/TwoColumnPoints';
import SectionHeader from '../Components/SectionHeader/SectionHeader';
import TextCaption from '../Components/TextCaption/TextCaption';

function Careers() {

    const isMobile = window.innerWidth <= 768;
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);
    const listItems = ["Food or meal vouchers", "Health insurance", "Dental plan", "Life insurance", "Education and language aid", "Application courses for qualification in the sector", "Daycare assistance for children up to 6 years old", "Bonus for the birthday boy of the month",]

    return (
        <div>
            <CenterStage title={"Your career, many advantages"} imageSrc={imgHANSAFLEX_Ireland_career_cover} paragraph={"At HANSA-FLEX, we know that employees can only perform at their best when they are comfortable. That's why, as an employer, As a family-owned company with flat hierarchies, we encourage inter-unit exchanges and new forms of teamwork.We promote unity through various company events and joint activities"} />
            {isMobile ?
                <>
                    <div style={{ backgroundColor: '#30557d', padding: '20px', color: 'white', paddingLeft: '10%' }}>
                        <Row>
                            <Col xs={12} md={6}>
                                <h2>Apply Now !</h2>
                                <p>
                                    <MdLocationOn /> HANSA-FLEX (IFP) INDIA PVT. LTD. <br />
                                    Plot No PAPV95, MIDC, Chakan Industrial Area, Village Vasuli, Taluka Khed, Pune, Maharashtra – 410501, India

                                    <MdEmail /> Email us at <a href="mailto:ni.info@hansa-flex.com" style={{ color: 'white' }}>ni.info@hansa-flex.com</a> now!
                                </p>
                            </Col>
                        </Row>
                    </div>

                </> : <Promoter title={"Contact us now !"} checklistItems={["Forge your path with passion and precision at HANSA-FLEX, where every challenge fuels innovation and every opportunity sparks growth", "Email us at ni.info@hansa-flex.com"]} imageUrl={imgHANSAFLEX_Ireland_career_contactus} />}

            {/* <SectionHeader title="Open feedback culture and collective actions" />
            <TextCaption
                title=""
                bulletPoints={[
                    "As a family-owned company with flat hierarchies, we encourage inter-unit exchanges and new forms of teamwork",
                    "We promote unity through various company events and joint activities",

                ]} /> */}

            {/* <div>
                <TwoColumnPoints points={listItems} title={"Our benefits"} subtitle={"Send your resume to: rh@hansa-flex.com"} />
            </div> */}

        </div>
    );
}

export default Careers;